import type { OrderLineDto } from "@/api/dtos";
import type { OrderLine } from "@/api/order/_models/Order";
import { toExternalStatusFromOrderExternalStatusDto } from "./toExternalStatusFromOrderExternalStatusDto";

export const toOrderLineFromOrderLineDto = (dto: OrderLineDto): OrderLine => {
  const externalStatuses = (dto.externalStatuses ?? []).map((x) =>
    toExternalStatusFromOrderExternalStatusDto(x),
  );

  return {
    id: dto.id,
    sku: dto.sku,
    orderedQuantity: dto.orderedQuantity ?? undefined,
    unitPrice: dto.unitPrice ?? undefined,
    total: dto.total ?? undefined,
    externalStatuses,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};
